import { styled } from '@material-ui/core';

export const DateText = styled('div')(({ theme: { palette } }) => ({
  color: palette.primary.main,
  fontWeight: 'bold',
}));
